function getObjectType(object) {
  return Object.prototype.toString.call(object).slice(8, -1);
}

export default getObjectType;


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/lib/utils/getObjectType.js
// module id = null
// module chunks = 